
import { Component,  inject,  OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-brand-advantage',
  templateUrl: './brand-advantage.component.html',
  styleUrls: ['./brand-advantage.component.scss'],
  
})
export class BrandAdvantageComponent implements OnInit {

  active = "explosive growth and momentum";
  router: Router = inject(Router)
  constructor() {
   
  }

  ngOnInit(): void {
   
  }

  handleTouchPoint(){
   this.router.navigate(['/development'])
  }
  

}

